import React from 'react';
import Button from '@mui/material/Button';
import { Link, useParams } from 'react-router-dom';
import styles from './GoalHierarchyForm.module.scss';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import useAuth from '../../../../../../../hooks/useAuth';
import UnfoldLessOutlinedIcon from '@mui/icons-material/UnfoldLessOutlined';
import UnfoldMoreOutlinedIcon from '@mui/icons-material/UnfoldMoreOutlined';
import useTreeEditor from '../../../../../../../hooks/useTreeEditor';
import GroupRemoveIcon from '@mui/icons-material/GroupRemove';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import CropFreeIcon from '@mui/icons-material/CropFree';

export default function GoalHierarchyForm() {
  const { teamId } = useParams();
  const { currentUser } = useAuth();
  const isLead = currentUser.teams.filter((t) => t.id === teamId)?.[0]?.isLead;
  const { isExpanded, setIsExpanded, filter, updateFilter } = useTreeEditor();
  return (
    <div className={styles.goalHierarchyForm}>
      {isLead && (
        <Button
          sx={{ background: '#ffffff' }}
          component={Link}
          to={'edit'}
          variant="outlined"
          startIcon={<EditOutlinedIcon />}
        >
          Edit Goal Hierarchy
        </Button>
      )}
      <Button
        onClick={() => setIsExpanded((current) => !current)}
        variant="outlined"
        sx={{ background: '#ffffff' }}
        startIcon={isExpanded ? <UnfoldLessOutlinedIcon /> : <UnfoldMoreOutlinedIcon />}
      >
        {isExpanded ? 'Condense view' : 'Expand view'}
      </Button>
      <Button
        onClick={() => updateFilter({ displayTeamGoals: !filter?.displayTeamGoals })}
        variant={filter?.displayTeamGoals ? 'outlined' : 'contained'}
        sx={filter?.displayTeamGoals ? { background: '#ffffff' } : {}}
        startIcon={filter?.displayTeamGoals ? <GroupRemoveIcon /> : <GroupAddIcon />}
      >
        {`${filter?.displayTeamGoals ? 'Hide' : 'Show'} Team Goals`}
      </Button>
      {filter?.focusedNode !== null && (
        <Button onClick={() => updateFilter({ focusedNode: null })} variant="contained" startIcon={<CropFreeIcon />}>
          Show Entire Hierarchy
        </Button>
      )}
    </div>
  );
}
